import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Button, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import LGModalCrud from "../../organisms/LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import InboundForm from "../../organisms/Inventory/InboundForm.tsx";
import { deleteInbound, getInboundList } from "../../api/inbounds/index.ts";
import dayjs from "dayjs";
import InboundTable from "../../organisms/Inventory/InboundTable.tsx";
import OutboundTable from "../../organisms/Inventory/OutboundTable.tsx";
import TransformationTable from "../../organisms/Inventory/TransformationTable.tsx";
import DevolutionTable from "../../organisms/Inventory/DevolutionTable.tsx";
import InventoryTagForm from "../../organisms/Inventory/InventoryTagForm.tsx";
import PhysicalInventoryCountTable from "../../organisms/Inventory/PhysicalInventoryCountTable.tsx";
import ProductRequestTable from "../../organisms/ProductRequests/ProductRequestTable.tsx";

const InventoryScreen = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label={`Entradas`} />
          <Tab label={`Salidas`} />
          <Tab label="Transformaciones" />
          <Tab label="Devoluciones" />
          <Tab label="Marbete" />
          <Tab label="Existencias" />
          <Tab label="Apartados" />
          <Tab label="Catálogos" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <Box sx={{ mt: 8 }}>
          <InboundTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ mt: 8 }}>
          <OutboundTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={2}>
        <Box sx={{ mt: 8 }}>
          <TransformationTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={3}>
        <Box sx={{ mt: 8 }}>
          <DevolutionTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={4}>
        <Box sx={{ mt: 8 }}>
          <InventoryTagForm />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={5}>
        <Box sx={{ mt: 8 }}>
          <PhysicalInventoryCountTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={6}>
        <Box sx={{ mt: 8 }}>
          <ProductRequestTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={7}>
        <Box sx={{ mt: 8 }}>
          <Typography>En construcción</Typography>
        </Box>
      </LGTabPanel>
    </DashboardLayout>
  );
};

export default InventoryScreen;
